import { Center, Loader } from '@mantine/core';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import type { AppRole } from '../api/types';
import { useAuth } from './AuthContext';
import { returnTo } from './returnTo';

interface RequireAuthProps {
  /** Если задано, пускаем только владельцев одной из ролей. */
  roles?: AppRole[];
}

export function RequireAuth({ roles }: RequireAuthProps) {
  const { isAuthenticated, isRestoring, hasRole } = useAuth();
  const location = useLocation();

  // Пока сессия восстанавливается, показывать страницу входа нельзя:
  // иначе при обновлении страницы пользователя выкидывало бы из кабинета.
  if (isRestoring) {
    return (
      <Center h={200}>
        <Loader />
      </Center>
    );
  }

  if (!isAuthenticated) {
    // Запоминаем, куда шли, чтобы вернуть туда после входа. Вместе с запросом:
    // в ссылке на пропущенный месяц он и есть самое важное.
    returnTo.save(location.pathname + location.search + location.hash);
    return <Navigate to="/login" replace />;
  }

  if (roles !== undefined && !roles.some(hasRole)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
